import "./Footer.css"
import * as translator from "../../utils/translator";
import { useNavigate } from "react-router-dom";

interface FooterProps {
    page: string;
    language?: string;
    showDiscountDisclaimer?: boolean;
    layoutOptions?: string;
    onNextClick?: () => void;
    onBackClick?: () => void;
    showFooterNext?: boolean;
}

export const Footer:React.FC<FooterProps> = ({ language, page, showDiscountDisclaimer=false, layoutOptions, onNextClick, onBackClick, showFooterNext=false }) => {

    const navigate = useNavigate();
    const nowYear = new Date().getFullYear();

    // Simplified footer for CheckoutRegister and RegistrationPage
    if (page === "CheckoutRegister" || page === "RegistrationPage") {
        return (
            <footer className={`${layoutOptions}`} style={{ background: 'transparent', border: 'none' }}>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
                    <span className="footer-copyright" style={{ textAlign: 'center' }}>
                        © {nowYear} DoktorABC.com 
                    </span>
                </div>
            </footer>
        );
    }

    const getFooterStylingByPage = () => {
        if (page === "Questionnaire") {
            return {
            footerJustifyContent: "space-between",
            showFooterReturn: true,
            footerTextAlign: "center",
            };
        }

        else if (page === "ChooseTreatment" || page === "ChooseTreatmentLandingPage" || page === "MyAccount") {
            return {
            footerJustifyContent: "center",
            showFooterReturn: false,
            footerTextAlign: "center",
            };
        }

        else if (page === "Shipping") {
            return {
            footerJustifyContent: "space-between",
            showFooterReturn: true,
            footerTextAlign: "end",
            };
        }


        else if (page === "CustomerVerification") {
            return {
            footerJustifyContent: "space-between",
            showFooterReturn: true,
            showFooterNext: showFooterNext,
            footerTextAlign: "end",
            };
        }

        else{
            return {
                footerJustifyContent: "center",
                showFooterReturn: false,
                footerTextAlign: "center",
            };
        }
    };

    let footerStyling = getFooterStylingByPage();


  return (
    <footer className={`footer-container ${layoutOptions}`}>
        <div style={{justifyContent:footerStyling.footerJustifyContent}} className="footer">

            <div className="footer-navigation">
                { footerStyling.showFooterReturn && 
                    <a className="footer-return" onClick={onBackClick || (() => navigate(-1))}>{translator.translate(language, "default", "Footer/return")}</a>
                }
                { footerStyling.showFooterNext && 
                    <a className="footer-next" onClick={onNextClick || (() => navigate(1))}>{translator.translate(language, "default", "Footer/next")}</a>
                }
            </div>

            <div style={{textAlign:footerStyling.footerTextAlign}  as React.CSSProperties } className="footer-text-container">
            {
                showDiscountDisclaimer && language ?
                <span className="footer-discount_disclaimer">
                    {translator.translate(language, "default", "SubscriptionModal/modal_condition_1")}<br/>
                    {translator.translate(language, "default", "SubscriptionModal/modal_condition_2")}
                </span>
                :
                null
            }
             <span style={{textAlign:footerStyling.footerTextAlign}  as React.CSSProperties } className="footer-copyright">
                © {nowYear} DoktorABC.com 
             </span>
            </div>
         
        </div>
    </footer>
  )
}


export default Footer;